import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { Section } from 'foundations-components/transitional/components/Section';
import { List } from 'foundations-components/transitional/components/List';
import Rating from 'marketplace-ui-reviews/components/Rating';
import ReviewBody from 'marketplace-ui-reviews/components/ReviewBody';
import ReviewerInfo from 'marketplace-ui-reviews/components/ReviewerInfo';
import ReviewReplyThread from 'marketplace-ui-reviews/components/ReviewReplyThread';
import { RatingAxes } from 'marketplace-ui-reviews/constants/RatingAxes';
// @ts-expect-error untyped dependency
import withReportModalState from './withReportModalState';
import { View as FoundationsView } from 'foundations-components/transitional/components/View';

// Renders a complete review item given a review. ReviewsList iterates through
// a list of reviews and calls the Renderer to display each one
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function DetailsReviewRenderer({
  borderBottom,
  isCustomer,
  onReplyModalOpen,
  review,
  reviewModalOpen,
  replyModalOpen,
  reportReviewModal,
  reportReplyModal,
  reviewActionsList,
  searchTerm,
  showOriginal,
  showUntranslatedText,
  onTrackInteraction
}) {
  const rating = showOriginal ? review.get('original').ratings.get(RatingAxes.OVERALL) : review.getIn(['ratings', RatingAxes.OVERALL]);
  return /*#__PURE__*/_jsxs(View, {
    borderBlockEndStyle: borderBottom ? 'solid' : 'none',
    borderColor: "border-core-default",
    borderWidth: "100",
    inlineSize: "100%",
    paddingBlock: "800",
    children: [/*#__PURE__*/_jsx(Section, {
      children: /*#__PURE__*/_jsx(Rating, {
        direction: "column",
        label: /*#__PURE__*/_jsxs(List, {
          inline: true,
          use: "inline-divided",
          wrapChildren: true,
          children: [/*#__PURE__*/_jsx(FormattedDateTime, {
            value: review.get('createdAt'),
            format: "ll",
            type: "userTz"
          }), review.get('lastEditedAt') && /*#__PURE__*/_jsxs("span", {
            children: [/*#__PURE__*/_jsx(FoundationsView, {
              marginInlineEnd: "100",
              as: "span",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "appMarketplace.detail.reviews.edit.edited"
              })
            }), /*#__PURE__*/_jsx(FormattedDateTime, {
              value: review.get('lastEditedAt'),
              format: "ll",
              type: "userTz"
            })]
          })]
        }),
        rating: rating,
        showTextRating: true
      })
    }), /*#__PURE__*/_jsx(ReviewBody, {
      review: review,
      searchTerm: searchTerm,
      showOriginal: showOriginal,
      showUntranslatedText: showUntranslatedText,
      onTrackInteraction: onTrackInteraction
    }), /*#__PURE__*/_jsx(ReviewerInfo, {
      inline: true,
      review: review
    }), reviewActionsList, /*#__PURE__*/_jsx(ReviewReplyThread, {
      reply: review.getReply(showUntranslatedText),
      onReportReplyClick: isCustomer ? onReplyModalOpen : undefined
    }), reviewModalOpen && reportReviewModal, replyModalOpen && reportReplyModal]
  });
}
export default withReportModalState(DetailsReviewRenderer);